import { render } from "./CampaignsCard.vue?vue&type=template&id=6825c20a"
import script from "./CampaignsCard.vue?vue&type=script&lang=js"
export * from "./CampaignsCard.vue?vue&type=script&lang=js"

import "./CampaignsCard.vue?vue&type=style&index=0&id=6825c20a&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__